module.exports = __webpack_public_path__ + "static/media/hero-image.ce073335.png";